// Utility to safely parse points values (may come as string or number)
export function parsePoints(value) {
  const n = Number(value);
  return Number.isFinite(n) ? Math.floor(n) : 0;
}

export function normalizePointsValue(value) {
  if (value == null || value === '') {
    return value;
  }

  return parsePoints(value);
}

export function normalizeUserPointsData(userData) {
  if (!userData || typeof userData !== 'object' || Array.isArray(userData)) {
    return userData;
  }

  if (userData.points == null || userData.points === '') {
    return userData;
  }

  return {
    ...userData,
    points: parsePoints(userData.points),
  };
}

export function normalizeProductPointsData(productData) {
  if (
    !productData ||
    typeof productData !== 'object' ||
    Array.isArray(productData)
  ) {
    return productData;
  }

  const normalizedProductData = { ...productData };

  if (
    normalizedProductData.points != null &&
    normalizedProductData.points !== ''
  ) {
    normalizedProductData.points = parsePoints(normalizedProductData.points);
  }

  if (Array.isArray(normalizedProductData.variables)) {
    normalizedProductData.variables = normalizedProductData.variables.map(
      (variable) => {
        if (
          !variable ||
          typeof variable !== 'object' ||
          variable.points == null ||
          variable.points === ''
        ) {
          return variable;
        }

        return {
          ...variable,
          points: parsePoints(variable.points),
        };
      },
    );
  }

  return normalizedProductData;
}

export default parsePoints;
